import type { CoinMode } from '@ui/hooks/useCoinMode';
import type { GardenType, GardenView } from '@ui/utils/garden';
import type { LiquidityStrategyView } from '@ui/utils/strategy';

export const PATH_DASHBOARD = '/dashboard';
export const PATH_DASHBOARD_ATOM = '/dashboard-atom';
export const PATH_DASHBOARD_VNO = '/dashboard-vno';
export const PATH_VNO = '/vno';
export const PATH_STATS_VNO = '/stats/vno';
export const PATH_STATS_STAKING = '/stats/staking';

type PathDict = {
  landing: string;
  landingDetail: string;
  dashboard: string;
  dashboardVno: string;
  dashboardAtom: string;
  vno: string;
  stake: string;
  useLiquid: string;
  unstake: string;
  claim: string;
  statsVno: string;
  statsStaking: string;
  garden: Record<GardenType, Record<GardenView, string>>;
  strategy: Record<LiquidityStrategyView, string>;
};

const croPathDict: PathDict = {
  landing: '/',
  landingDetail: '/cro',
  dashboard: PATH_DASHBOARD,
  dashboardVno: PATH_DASHBOARD_VNO,
  dashboardAtom: PATH_DASHBOARD_ATOM,
  vno: PATH_VNO,
  stake: '/cro/stake',
  useLiquid: '/cro/use-lcro',
  unstake: '/cro/unstake',
  claim: '/cro/claim',
  statsVno: PATH_STATS_VNO,
  statsStaking: PATH_STATS_STAKING,
  garden: {
    FERRO: {
      PLANT: '/vno/garden/ferro',
      WITHDRAW: '/vno/garden/ferro/withdraw',
      GROW_WATER: '/vno/garden/ferro/grow',
      GROW_HELPERS: '/vno/garden/ferro/grow/helper',
      HARVEST: '/vno/garden/ferro/harvest',
    },
    TECTONIC: {
      PLANT: '/vno/garden/tectonic',
      WITHDRAW: '/vno/garden/tectonic/withdraw',
      GROW_WATER: '/vno/garden/tectonic/grow',
      GROW_HELPERS: '/vno/garden/tectonic/grow/helper',
      HARVEST: '/vno/garden/tectonic/harvest',
    },
    VVS: {
      PLANT: '/vno/garden/vvs',
      WITHDRAW: '/vno/garden/vvs/withdraw',
      GROW_WATER: '/vno/garden/vvs/grow',
      GROW_HELPERS: '/vno/garden/vvs/grow/helper',
      HARVEST: '/vno/garden/vvs/harvest',
    },
    VVS_CRO: {
      PLANT: '/vno/garden/vvs-cro',
      WITHDRAW: '/vno/garden/vvs-cro/withdraw',
      GROW_WATER: '/vno/garden/vvs-cro/grow',
      GROW_HELPERS: '/vno/garden/vvs-cro/grow/helper',
      HARVEST: '/vno/garden/vvs-cro/harvest',
    },
  },
  strategy: {
    deposit: '/strategy/cro-liquidity',
    withdraw: '/strategy/cro-liquidity/withdraw',
    dashboard: '/dashboard?tab=strategy',
  },
};

const atomPathDict: PathDict = {
  landing: '/',
  landingDetail: '/atom',
  dashboard: PATH_DASHBOARD,
  dashboardVno: PATH_DASHBOARD_VNO,
  dashboardAtom: PATH_DASHBOARD_ATOM,
  vno: PATH_VNO,
  stake: '/atom/stake',
  useLiquid: '/atom/use-latom',
  unstake: '/atom/unstake',
  claim: '/atom/claim',
  statsVno: PATH_STATS_VNO,
  statsStaking: PATH_STATS_STAKING,
  garden: {
    FERRO: {
      PLANT: '/vno/garden/ferro-atom',
      WITHDRAW: '/vno/garden/ferro-atom/withdraw',
      GROW_WATER: '/vno/garden/ferro-atom/grow',
      GROW_HELPERS: '/vno/garden/ferro-atom/grow/helper',
      HARVEST: '/vno/garden/ferro-atom/harvest',
    },
    TECTONIC: {
      PLANT: '/vno/garden/tectonic-atom',
      WITHDRAW: '/vno/garden/tectonic-atom/withdraw',
      GROW_WATER: '/vno/garden/tectonic-atom/grow',
      GROW_HELPERS: '/vno/garden/tectonic-atom/grow/helper',
      HARVEST: '/vno/garden/tectonic-atom/harvest',
    },
    VVS: {
      PLANT: '/vno/garden/vvs-atom',
      WITHDRAW: '/vno/garden/vvs-atom/withdraw',
      GROW_WATER: '/vno/garden/vvs-atom/grow',
      GROW_HELPERS: '/vno/garden/vvs-atom/grow/helper',
      HARVEST: '/vno/garden/vvs-atom/harvest',
    },
    // TODO will not be used
    VVS_CRO: {
      PLANT: '/vno/garden/vvs-atom',
      WITHDRAW: '/vno/garden/vvs-atom/withdraw',
      GROW_WATER: '/vno/garden/vvs-atom/grow',
      GROW_HELPERS: '/vno/garden/vvs-atom/grow/helper',
      HARVEST: '/vno/garden/vvs-atom/harvest',
    },
  },
  strategy: {
    deposit: '/strategy/atom-liquidity',
    withdraw: '/strategy/atom-liquidity/withdraw',
    dashboard: '/dashboard?tab=strategy',
  },
};

export const pathDict: Record<CoinMode, PathDict> = {
  cro: croPathDict,
  atom: atomPathDict,
};
